import axios from 'axios';
// import { SECOND_BASE_URL, TEST_URL } from "./constants";

export const $api = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_TEST_URL}/client`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

export const $apiWithoutClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_TEST_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

export const $apiNews = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SECOND_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});
